<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

<app-pulsemenu></app-pulsemenu>
<div class="container2" *ngIf="doctor && doctor.length>0">
<div class="row text-left" *ngIf="searchflag != 1">
    <div class="col-12">
        <p style="color:#9b7544; font-size:20px">
           Search Result For: {{searchterm}}
        </p>
    </div>
</div>
<div class="row" >
  <div class="col-12"  *ngFor="let data of doctor |search:  searchterm | special: special | geolocationdistance : currentLocation
  | paginate: { itemsPerPage: 10, currentPage: p}" >
    <div class="card" style="color: #cb983f" style="margin-top: 2%" *ngIf="!(data.distance && data.distance>100)" >
        <div class="card-body" >
            <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                        <img class="card-img-top docimg" src="https://passport.petcart.in/images/userimgs/{{data.photo}}"
                        alt="image description"  routerLink="/pulse/doctordetail/{{data.id}}">
                </div>
                <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
                        <h4 style="color:#9b7544" class="card-title"  routerLink="/pulse/doctordetail/{{data.id}}">{{data.name}}</h4>
                        <p  style="color:#9b7544" class="card-text"  routerLink="/pulse/doctordetail/{{data.id}}">{{data.qualification}}</p>
                        <p  style="color:#9b7544" class="card-text hidden-sm-down"  routerLink="/pulse/doctordetail/{{data.id}}">{{data.experience}}</p>
                        <div class="row">
                                <div class="col-2" style="color:#9b7544" >
                                    <mat-icon>place</mat-icon>
                                </div>
                                <div class="col-10" style="color:#9b7544" >
                                    {{data.address}}
                                </div>
                              </div>
                              <p style="cursor: pointer; color:#9b7544" *ngIf="data.distance">{{data.distance}} km
                                  (Approx Arial Distance) <br>-
                                  <a (click)="getDirection(data.lat, data.lon)">Click Here to view Actual Distance and Direction </a>
                              </p>
                </div>
            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4" *ngIf="servicemunus && services">
                <div class="col-12 text-center hidden-sm-down">
                    <p style="font-size:18px; color:#9b7544">
                     <button (click)="showServices(data.id)">   <strong >SERVICES </strong> </button>
                    </p>
                </div>

                    <div class="row" style="margin-top:50px" >
                            <button class="btn btn-success btn-block" end clear
                            style="margin-bottom: 1%" (click)="bookAppointment(data.id)"
                           >Book Appointment</button>
                        </div>
                </div>
            </div>
            </div>
        </div>
    </div>
  </div>
  <div class="row" *ngIf="doctor">
        <div class="col-12 text-right" style="font-size:18px ; color:#9b7544">
            <pagination-controls  (pageChange)="p = $event"></pagination-controls >
        </div>
      </div>
</div>
